import * as React from 'react';

import styles from './TextMessageLayout.css';
import { EMessageType } from '../../types/messageType';
import { EUserColor } from '../../types/userName';
import { ChatMessageBubble } from '../ChatMessageBubble';
import { ChatMessage } from '../ChatMessage';

interface ITextMessageLayoutProps {
  errorSign: React.ReactNode;
  errorText: React.ReactNode;
  messageType: EMessageType;
  isLastMessageInChain: boolean;
  userName: React.ReactNode;
  textMessage: React.ReactNode;
  messageMeta: React.ReactNode;
  actionButtons: React.ReactNode;
  userColor?: EUserColor;
  replyQuote?: React.ReactNode | null;
  highlighted?: boolean;
  onHighlightEnd?: VoidFunction;
}

export const TextMessageLayout = React.forwardRef<HTMLDivElement, ITextMessageLayoutProps>(function TextMessageLayout(
  {
    errorSign,
    errorText,
    messageType,
    isLastMessageInChain,
    userName,
    textMessage,
    messageMeta,
    actionButtons,
    userColor,
    replyQuote,
    highlighted,
    onHighlightEnd,
  },
  ref,
) {
  return (
    <ChatMessage errorSign={errorSign} errorText={errorText}>
      <ChatMessageBubble
        messageType={messageType}
        withTail={isLastMessageInChain}
        ref={ref}
        userColor={userColor}
        highlighted={highlighted}
        onHighlightEnd={onHighlightEnd}
      >
        <div className={styles['username']}>{userName}</div>
        <div className={styles['quote']}>{replyQuote}</div>
        <div className={styles['layout']}>
          <div className={styles['content']}>
            {textMessage}
            {actionButtons}
          </div>
          <div className={styles['meta']}>{messageMeta}</div>
        </div>
      </ChatMessageBubble>
    </ChatMessage>
  );
});
